// Module
var code = "<div class=\"ZoomedPdfViewerPage\">\n  <div class=\"ZoomedPdfViewerPage__container\">\n    <div class=\"ZoomedPdfViewerPage__image\"></div>\n    <div class=\"ZoomedPdfViewerPage__toolbox\"></div>\n  </div>\n</div>\n";
// Exports
export default code;